/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.21.20
Tree Replant Display: Displays data for viewing & prior to submission
**********************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TreeReplantTable from './tree_replant_table';

const propTypes = {
  user: PropTypes.object,
  data: PropTypes.object,
  approver: PropTypes.object,
  employees: PropTypes.array,
  editingApplication: PropTypes.bool,
  prevReplants: PropTypes.array,
  toDelete: PropTypes.bool
};

const TreeReplantDisplay = ({ data, prevReplants, toDelete, editingApplication }) => {
  return (
    <div>
      <div>
        
        { toDelete ? <h2 className="red-text chem-app-flex">Are you sure you want to delete the following replant?</h2> : '' }
        { editingApplication ? <span className="app-log-header blue-text">Editing Tree Replant</span>
          : <div>
              <span className="right"><i className="material-icons green-text medium">local_florist</i></span>
              <span className="app-log-header">Tree Replant Log</span>
            </div>
        }<br />
        <hr />
        {
          prevReplants.length > 0 ?
            <div className="row">
              <h5 className="blue-text app-log-prev-header">Previous Replants - { data.location }, Field { data.field }</h5>
              <TreeReplantTable replants={prevReplants} readOnly={true} />
            </div>
            
          : ''
        }
        <div className="row">
          <div className="col s12">
          <h5 className="blue-text app-log-prev-header">Replant Record</h5>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Date</strong>
            <p>{ moment(data.date).format("dddd, MMMM Do YYYY") }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Location</strong>
            <p>{ data.location === '71' ? '71 - Kau' : '72 - Keaau' }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Field</strong>
            <p>{ data.field }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <b>Total Trees to Plant</b>
            <p>{ data.totalTrees }</p>
          </div>
          <hr />
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Hours</strong>
            <p>{ data.hours }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Trees Planted</strong>
            <p>{ data.treesPlanted }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Trees Remaining</strong>
            <p>{ data.treesRemaining }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Trees per hour</strong>
            <p>{ data.treesPerHour }</p>
          </div>
          
          <div className="col s12">
            <br />
            <div className="divider"></div>
            <div className="section chem-app-flex">
              <p>
                <strong><u>Employees</u></strong> <br />
                { data.addedEmployees.map((e) => (
                  <span key={e.eid}><b>{ e.name }</b>, { e.position }<br /></span>
                )) }
              </p>
              <p><b>Comments: </b>{ data.comments }</p>
            </div>
            <div className="divider"></div>
          </div>
        </div>
      </div>
    </div>
  );
}


TreeReplantDisplay.propTypes = propTypes;
export default TreeReplantDisplay;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_replant_display.js